/**
 * Инструкция для сотрудника: зачем героиня, что такое канон, пять шагов, статусы и деньги.
 * Раскрыта у новой героини (запусков нет), у рабочей свёрнута в одну строку.
 */
import type { ReactNode } from "react";

function Step({ n, title, children }: { n: number; title: string; children: ReactNode }) {
  return (
    <li className="grid grid-cols-[20px_1fr] gap-2">
      <span className="tnum text-fg-faint">{n}.</span>
      <span>
        <b className="font-medium text-fg">{title}.</b> {children}
      </span>
    </li>
  );
}

export function PersonaGuide({ open }: { open: boolean }) {
  return (
    <details
      open={open}
      className="rounded-[var(--radius-card)] border border-border bg-bg-subtle px-4 py-3"
      data-annot="инструкция героини"
    >
      <summary className="cursor-pointer text-[13px] font-medium text-fg select-none">Как работать с героиней</summary>
      <div className="mt-3 grid max-w-[880px] gap-3 text-[12.5px] leading-relaxed text-fg-muted">
        <p>
          <b className="font-medium text-fg">Зачем.</b> Рилсам нужна постоянная героиня — одна и та же женщина из ролика
          в ролик, похожая на живую, без «глянца ИИ». Потом на неё наденем наши платья и поставим в позу с референса
          Pinterest. Героиня полностью выдуманная: лица реальных людей и с фото Pinterest не используем.
        </p>
        <p>
          <b className="font-medium text-fg">Главное — канон.</b> Цель экрана — две утверждённые картинки героини:{" "}
          <b className="font-medium text-fg">канон портрета</b> (лицо) и{" "}
          <b className="font-medium text-fg">канон листа</b> (ракурсы и полный рост). Канон выбирает человек: откройте
          лучшую картинку → «Сделать каноном». После этого каждый следующий запуск получает канон как образец «это та же
          женщина» — лицо не уплывает. Без канона каждая генерация рисует новую женщину. Портрет и лист потом пойдут в
          примерку наших платьев.
        </p>
        <ol className="grid gap-1.5">
          <Step n={1} title="Бриф">
            Опишите героиню по-русски, как рассказали бы фотографу: возраст, внешность, волосы, характер, стиль.
            Сохраняется сам, когда выходите из поля.
          </Step>
          <Step n={2} title="Промпт">
            «Составить промпт» — ИИ переведёт бриф в английский фотопромпт (≈ $0.01). Текст можно поправить руками и
            «Сохранить как версию»; старые версии v1, v2… не пропадают.
          </Step>
          <Step n={3} title="Портрет">
            Выберите модели (по умолчанию отмечены три самые дешёвые) и число вариантов на модель. Цена видна до
            запуска. Один промпт уходит в разные модели — в ленте справа сравниваете, какая справилась лучше.
          </Step>
          <Step n={4} title="Итерации">
            Нажмите на картинку — справа откроется панель. «Что хорошо (оставить)» и «Что плохо (изменить)» →
            «Следующая итерация»: система сама допишет правку в промпт. Одна главная правка за шаг. На глубине 4 и
            больше лицо начинает «плыть» — тогда «Пересобрать из канона».
          </Step>
          <Step n={5} title="Канон">
            «Сделать каноном» на лучшем портрете → в блоке «Канон» станет доступен «Лист персонажа» → на лучшем листе
            «Сделать каноном листа». Героиня получит статус «Утверждена».
          </Step>
        </ol>
        <p>
          <b className="font-medium text-fg">Статусы картинок:</b> «Новая» — ещё не оценена; «Одобрена» — нравится,
          от неё можно продолжать; «Отклонена» — не подходит; «Канон» — эталон, один на портрет и один на лист.
        </p>
        <p>
          <b className="font-medium text-fg">Деньги.</b> Каждый запуск платный. «≈» — оценка, «по спайку» — фактов о
          цене пока мало. Дороже $1 — кнопка попросит второй клик. Модель отказала — «деньги не списаны». Все траты — в
          «Журнале вызовов».
        </p>
      </div>
    </details>
  );
}
